import Swiper from 'react-id-swiper';
import { useEffect, useState } from 'react';
import Icon from '@/assets/icons';
import { Article } from '@/components';

export default function ArticlesSlider({ items }) {
  const [swiper, getSwiper] = useState(null);

  const swiperParams = {
    getSwiper: getSwiper,
    containerClass: 'swiper-container swiper-container--transparent',
    preventInteractionOnTransition: true,
    slidesPerView: 1,
    keyboard: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    watchOverflow: true,
    renderPrevButton: () => (
      <div className="swiper-button-prev">
        <Icon name="arrow-left" width="16" height="10" />
      </div>
    ),
    renderNextButton: () => (
      <div className="swiper-button-next">
        <Icon name="arrow-right" width="16" height="10" />
      </div>
    ),
    breakpoints: {
      // when window width is >= 700px
      700: {
        slidesPerView: 2,
      }
    }
  };

  useEffect(() => {
    if (swiper) {
      swiper.updateSlides()
    }
  })

  return (
    <Swiper {...swiperParams}>
      {items.map((article) => {
        const { id } = article;
        return <Article as="div" key={id} {...article} />;
      })}
    </Swiper>
  );
}
